import { Link } from "react-router-dom";
import { Mail, Globe, ArrowUpRight, ShieldCheck } from "lucide-react";
import { DOOSP_INFO, PROGRAMS } from "@/lib/programs";
import LegalDisclaimer from "@/components/LegalDisclaimer";

export default function DoospFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-zinc-900 text-zinc-400 mt-24" data-testid="doosp-footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center">
              <img
                src="/doosp_logo.png"
                alt="IMCAC — Department of Occupational Safety Programs"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-sm mt-4 max-w-md leading-relaxed">
              The {DOOSP_INFO.name} is a specialty division of {DOOSP_INFO.parentFull} (IMCAC). IMCAC and DOOSP operate as an independent competency assessment and certification body running competency-based workplace-health and safety assessments.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href={`mailto:${DOOSP_INFO.contactEmail}`} className="inline-flex items-center gap-2 text-xs text-zinc-400 hover:text-white">
                <Mail className="h-3.5 w-3.5" /> {DOOSP_INFO.contactEmail}
              </a>
            </div>
          </div>

          {/* Programs */}
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-white mb-4">Programs</div>
            <ul className="space-y-2 text-sm">
              {PROGRAMS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/programs/${p.slug}`} className="hover:text-white transition inline-flex items-center gap-1.5">
                    {p.shortName}
                    {p.status === "coming-soon" && (
                      <span className="text-[9px] font-mono uppercase text-amber-500">Soon</span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Organization */}
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-white mb-4">Organization</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition">About DOOSP</Link></li>
              <li><Link to="/certifications" className="hover:text-white transition">Certifications</Link></li>
              <li><Link to="/corporate" className="hover:text-white transition">Corporate Training</Link></li>
              <li><Link to="/become-instructor" className="hover:text-white transition">Become an Instructor</Link></li>
              <li><Link to="/resources" className="hover:text-white transition">Resource Centre</Link></li>
              <li><Link to="/news" className="hover:text-white transition">News &amp; Articles</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
              <li><Link to="/terms" className="hover:text-white transition">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">Privacy Policy</Link></li>
              <li><Link to="/verify" className="hover:text-white transition inline-flex items-center gap-1">
                Verify a certificate <ShieldCheck className="h-3 w-3" />
              </Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-zinc-500">
            © {year} IMCAC · International Medical Competency Accreditation Council. All rights reserved.
          </div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-zinc-500 flex items-center gap-4">
            <span className="flex items-center gap-1.5"><Globe className="h-3 w-3" /> Section 8 Non-Profit · Companies Act, 2013, India</span>
            <span>Curricula aligned to OSHA · CDC · WHO</span>
          </div>
        </div>

        <LegalDisclaimer variant="footer" className="mt-8 pt-6 border-t border-zinc-800" />
      </div>
    </footer>
  );
}
